<div class="flex flex-col items-end max-w-[1024px] px-4 mx-auto w-full pointer-events-none dialog-nav-menu">
  <button type="button" class="w-[46px] h-[46px] bg-white flex flex-col items-center justify-center rounded-[4px] cursor-pointer pointer-events-auto icon-cross-icon-wrap" mat-dialog-close>
    <mat-icon svgIcon="cross-icon" class="!w-full !h-auto max-w-[10px] max-h-[10px]"></mat-icon>
  </button>
  <div class="bg-white rounded-[8px] mt-[3px] min-w-[270px] pointer-events-auto">
    <ul>
      @if (!isBusinessAccount()) {
        <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300 ease-in-out rounded-t-[8px]">
          <button mat-dialog-close type="button" (click)="openRegisterBusinessAccountDialog()" class="min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142] w-full">
            <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
              <mat-icon svgIcon="briefcase" class="!w-full !h-auto max-w-[16px] max-h-[14px] text-[#323142]"></mat-icon>
            </span>
            Register Business Account
          </button>
        </li>
      }
      <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
        <button mat-dialog-close
          (click)="openDesktopBenefitsDialog()"
          type="button"
          class="min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142] w-full">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="desktop-icon" class="!w-full !h-auto max-w-[18px] max-h-[12px] text-[#323142]"></mat-icon>
          </span>
          Desktop Version
        </button>
      </li>
      @if (!accountAccessService.isExchangeRole() && !isPoliceAccount() && !isDeniedForViewer()) {
        <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
          <a routerLink="/pricing" mat-dialog-close class="min-h-[42px] w-full flex items-center px-2 py-2 gap-x-2 text-[#323142]">
            <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
              <mat-icon svgIcon="wallet-2" class="!w-full !h-auto max-w-[13px] max-h-[13px] text-[#323142]"></mat-icon>
            </span>
            Pricing for AML
          </a>
        </li>
      }
      <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
        <a mat-dialog-close routerLink="/security" class="min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[18px] h-[18px] text-[#323142]">
            <mat-icon svgIcon="shield-bold-stroke" class="!w-full !h-auto text-[#2F2E3E]"></mat-icon>
          </span>
          Security
        </a>
      </li>
      <li class="hover:bg-[#F0F4F5] transition-all duration-300">
        <button (click)="handleContactSupport()" type="button" class="min-h-[42px] w-full flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="support-icon" class="!w-full !h-auto max-w-[13px] max-h-[13px] text-[#323142]"></mat-icon>
          </span>
          Contact Support
        </button>
      </li>
    </ul>
    @if (!isDeniedForViewer() && !accountAccessService.isExchangeRole()) {
      <div class="px-2 flex flex-col justify-center min-h-[16px] bg-[#323142] text-white pl-[68px] text-[11px]
       font-medium font-inter uppercase tracking-[0.09em]">
        AML Actions
      </div>
      <ul>
        @if (isButtonWalletCheck() && !accountAccessService.isExchangeRole()) {
          <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
            <a mat-dialog-close routerLink="/monitoring-page" [queryParams]="{tab: 'check_wallet'}" class="pl-[66px] min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
              <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
                <mat-icon svgIcon="strikethrough-wallet-icon" class="!w-full !h-auto max-w-[19px] max-h-[12px] text-[#323142]"></mat-icon>
              </span>
              1-time Wallet check
            </a>
          </li>
        }
        @if (!accountAccessService.isExchangeRole()) {
          <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
            <a mat-dialog-close routerLink="/monitoring-page" [queryParams]="{tab: 'monitoring'}" class="pl-[66px] min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
              <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
                <mat-icon svgIcon="wallet-plus-icon" class="!w-full !h-auto max-w-[13px] max-h-[12px] text-[#323142]"></mat-icon>
              </span>
              24/7 Wallet Monitoring
            </a>
          </li>
        }
        @if (isAmlEnergyActive() && !accountAccessService.isExchangeRole()) {
          <li class="hover:bg-[#F0F4F5] transition-all duration-300">
            <a mat-dialog-close routerLink="/add-wallet" class="pl-[66px] min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
              <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
                <mat-icon svgIcon="fire" class="!w-full !h-auto max-w-[10px] max-h-[12px] text-[#323142]"></mat-icon>
              </span>
              AML Energy Package
            </a>
          </li>
        }
      </ul>

    }
    <div class="px-2 flex flex-col justify-center min-h-[16px] bg-[#323142] text-white pl-[68px] text-[11px]
     font-medium font-inter uppercase tracking-[0.09em]">
      @if (accountAccessService.isExchangeRole()) {
        AML REPORTS
      } @else {
        Wallets & AML REPORTS
      }
    </div>
    <ul>
      @if (!accountAccessService.isExchangeRole()) {
        <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
          <a mat-dialog-close routerLink="/subscribed-wallets" class="pl-[66px] min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
            <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
              <mat-icon svgIcon="menu-my-wallets" class="!w-full !h-auto max-w-[20px] max-h-[20px] text-[#323142]"></mat-icon>
            </span>
            My Wallets
          </a>
        </li>
      }
      <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
        <a mat-dialog-close routerLink="/reports" class="pl-[66px] min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="wallet-reports" class="!w-full !h-auto max-w-[15px] max-h-[14px] text-[#323142]"></mat-icon>
          </span>
          AML Reports
        </a>
      </li>
      <!-- <li class="hover:bg-[#F0F4F5] transition-all duration-300">
        <a mat-dialog-close routerLink="/transactions" class="pl-[66px] min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="transactions-reports-icon" class="!w-full !h-auto max-w-[15px] max-h-[15px] text-[#323142]"></mat-icon>
          </span>
          Transaction Reports
        </a>
      </li> -->
    </ul>
    <div class="px-2 text-center flex flex-col items-center justify-center min-h-[16px] bg-[#F0F4F5]
     font-medium font-inter uppercase text-[9px] tracking-[0.09em]">
      GENERAL
    </div>
    <ul>
      <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
        <a target="_blank" href="https://amlofficer.org" class="min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="slim-arrow-right" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-[#323142]"></mat-icon>
          </span>
          About us
        </a>
      </li>
      <li class="border-b border-solid border-[#D9E3E5] hover:bg-[#F0F4F5] transition-all duration-300">
        <a target="_blank" href="https://amlofficer.org/blog" class="min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="slim-arrow-right" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-[#323142]"></mat-icon>
          </span>
          Blog
        </a>
      </li>
      <li class="hover:bg-[#F0F4F5] transition-all duration-300 rounded-b-[8px]">
        <a target="_blank" href="https://starcompliance.io" class="min-h-[42px] flex items-center px-2 py-2 gap-x-2 text-[#323142]">
          <span class="flex flex-col items-center justify-center w-[20px] h-[20px]">
            <mat-icon svgIcon="slim-arrow-right" class="!w-full !h-auto max-w-[10px] max-h-[8px] text-[#323142]"></mat-icon>
          </span>
          Crypto Recovery
        </a>
      </li>
    </ul>
  </div>
</div>
